import React, { useEffect,useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setHeader } from '../../store/settings/settingsSlice'
import copyIcon from '../../assets/images/fluent_copy-select-20-filled.svg'
import arrowCircleDown from '../../assets/images/arrow-circle-down.svg'
import { fetchReferralSummary, fetchUserReferrals } from '../../store/auth/authActions'
import cogoToast from 'cogo-toast';
import style from './referrals.module.css'
import Modal from '../modal/Modal';
import Pagination from '../Pagination/Pagination';


const Referrals = () => {

  // const userData = useSelector(state => state.auth.user)
   const [inviteModal, setInviteModal] = useState(false);
  const dispatch = useDispatch();
  
    // Get referrals and loading state from Redux
  const referrals = useSelector(state => state.auth.referrals);
  const referralsLoading = useSelector(state => state.auth.referralsLoading);
  const refLink = useSelector(state => state.auth.fullUser.referral_code)
  const referralSummary = useSelector(state => state.auth.referralSummary)
  const referralsTotal = useSelector((state) => state.auth.referralsTotal);
  let PageSize = 20;
  const [currentPage, setCurrentPage] = useState(0);

  const copyInviteCode = () => {
      navigator.clipboard.writeText(refLink);
      cogoToast.success("Invite code copied to clipboard", {
        position: "top-right"
      });
  };


    const getMoreItemsByOffset = (page) => {
      setCurrentPage(page)
      dispatch(fetchUserReferrals({
        page: page
      }))
    }
  

  const copyInviteCodeWithLink = () => {
      const inviteLink = `https://app.astroafrica.site/signup?ref=${refLink}`;
      navigator.clipboard.writeText(inviteLink);
      cogoToast.success("Invite link copied to clipboard", {
        position: "top-right"
      });
  };

   // Helper for initials
  const getInitials = (first, last) => {
    return `${(first?.[0] || '').toUpperCase()}${(last?.[0] || '').toUpperCase()}`;
  };

  useEffect(() => {
      dispatch(setHeader("Referral"));
       dispatch(fetchUserReferrals({
        page: 0
       }));
       dispatch(fetchReferralSummary());
  }, [dispatch]);



  return (
    <>

      {/* ========= ==  INVITE MODAL */}
       <Modal
          canClose={true}
          modalOpen={inviteModal}
          setModalOpen={setInviteModal}
          title='Invite Friends'
          minWidth='35%'
          >
            <div style={{marginTop: '30px'}}>
                <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
              Want to share the fun? Invite a friend to join you! Send them an invite and enjoy the experience together.                    </p>
            </div>   

            <div style={{display: 'flex', gap:'10px', alignItems: 'center', marginTop: '30px'}}>
                <button onClick={() => setInviteModal(false)} className={style.deactivateBtn}>
                   Cancel
                </button>
                <button onClick={copyInviteCodeWithLink} className={style.save}>
                    Copy Invite Link
                </button>
             </div>     
        </Modal>


    {/* Overview */}
    <div className={style.referralsContainer}>
      <div className={style.card}>  
         <div>
          <p className={style.title}>
            Total Referrals
            </p>
              <div className={style.balance}>
                <p>
                {referralSummary ? referralSummary.referredCount : 0}
                </p>
              
              </div>
         </div>
      </div>
      <div className={style.card}>  
         <div>
          <p className={style.title}>
          Total Earned Bonus
            </p>
              <div className={style.balance}>
                <p>
                 {referralSummary ? referralSummary.currency_code : ''} {referralSummary ? referralSummary.redeemedSum.toLocaleString() : 0}
                </p>
               
              </div>
         </div>
      </div>
       
    </div>

    {/* Referral code section */}
    <div className={style.inviteCard}>
        <div>
            <h6 className={style.inviteTitle}>Invite friends, get rewarded</h6>
            <p className={style.inviteSubTitle}>
             You will get <span>NGN {referralSummary ? referralSummary.bonusAmountNaira: 0}</span> or <span>GHS {referralSummary ? referralSummary.bonusAmountGhana: 0}</span> credited when they sign up and trade up to  <span>{referralSummary ? referralSummary.thresholdAmountUSD : 0} USD</span> or more.
             Please note we can stop or change this offer at any time. <span style={{cursor: 'pointer', color: '#40196D'}}>T&Cs apply</span>
            </p>
        </div>

        <div className={style.inviteCTA}>
            <div onClick={copyInviteCode} className={style.copyDiv}>
              <img src={copyIcon} alt="copy icon" />
               <h6>{refLink}</h6>
            </div>
            <button onClick={() => setInviteModal(true)} className={style.save}>
              Invite Friends
            </button>
        </div>
      
    </div>

    {/* Recent invites section */}
    <div className={style.recentInvitesDiv}>
      <h6 className={style.recentInvitesTitle}>Recent Invites</h6>

       {referralsLoading ? (
          <div style={{ padding: '2rem', textAlign: 'center' }}>Loading invites...</div>
        ) : referrals && referrals.length > 0 ? (
          referrals.map(ref => (
            <div key={ref.id} className={style.recentInviteCard}>
              <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                  <div className={style.avatar}>
                  {getInitials(ref.ReferredUser?.Profile?.first_name, ref.ReferredUser?.Profile?.last_name)}
                </div>
                <div>
                  <p className={style.name}>
                    {ref.ReferredUser?.Profile?.first_name} {ref.ReferredUser?.Profile?.last_name}
                  </p>
                </div>
              </div>
              <div>
                {/* show a status based on is_redeemed  */}
                {ref.is_redeemed ? (
                  <p className={style.redeemed}>Completed</p>
                ) : (
                  <p className={style.pending}>Pending</p>
                )}
              </div>
             
            </div>
          ))
        ) : (
          <div className={style.noInvite}>
            <p className={style.noInviteText}>No friend invited yet!</p>
            <button onClick={() => setInviteModal(true)} className={style.inviteButton}>
              Invite Now
              <img src={arrowCircleDown} alt="arrow icon" />
            </button>
          </div>
        )} 

         {referrals && referrals.length > 0 &&
         <div style={{display: 'flex', justifyContent: 'center', marginTop: '20px'}}>
            <Pagination
            currentPage={currentPage}
            totalCount={referralsTotal}
            pageSize={PageSize}
            onPageChange={(page) => getMoreItemsByOffset(page)}
            />
        </div> 
           }

    </div>
    </>
  );
}

export default Referrals;